import React from "react";
import logo from "./logo.svg";

import Navbar from "./components/Navbar/Navbar";
function NotFoundPage() {
	return (
		<div className="App">
			<header className="App-header">
				<Navbar />
				<img src={logo} className="App-logo" alt="logo" />
				<p>
					Edit <code>src/App.tsx</code> and save to reload.
				</p>
				<a
					className="App-link"
					href="https://reactjs.org"
					target="_blank"
					rel="noopener noreferrer"
				>
					Not Found Page
				</a>
			</header>
		</div>
	);
}

export default NotFoundPage;
